import $ from 'jquery';
import { initSwiper } from "./swiper";

const $competenceContainer = $('.js-competence-container')

$('.js-pick-category').on('change', function () {
    const $this = $(this)
    const value = $this.val()
    const isDashboard = location.href.includes('dashboard/my-competences')

    $competenceContainer.html(
        `<div class="text-center pt-8" style="height: 476px; width: 100%;"><div class="spinner-border text-white" role="status">
        <span class="visually-hidden">Loading...</span>
        </div></div>`
    );

    $.get(`/competence-slider-for-category/${value}/${isDashboard}`, data => {
        $competenceContainer.html(data)
        setTimeout(() => {
            $competenceContainer.find('.slider').each(initSwiper)
        }, 0)
    })
})

